import {
  checkContactsWith,
  checkProfileAccess,
  createChat,
  fetchChatById,
  fetchChatMessages,
  fetchChatWhere,
  fetchChats,
  fetchUnreadCount,
  markChatAsUnread,
  sendChatMessage,
} from './chat'

const chatApi = {
  fetchChatWhere: {
    key: 'FETCH_CHAT_WHERE',
    fn: fetchChatWhere,
  },
  getChatById: {
    key: 'FETCH_CHAT_BY_ID',
    fn: fetchChatById,
  },
  createChat: {
    key: 'CREATE_CHAT',
    fn: createChat,
  },
  sendMessage: {
    key: 'SEND_CHAT_MESSAGE',
    fn: sendChatMessage,
  },
  getChats: {
    key: 'FETCH_ALL_CHATS',
    fn: fetchChats,
  },
  getChatMessages: {
    key: 'FETCH_CHAT_MESSAGES',
    fn: fetchChatMessages,
  },
  getUnreadMessagesCount: {
    key: 'FETCH_UNREAD_MESSAGES_COUNT',
    fn: fetchUnreadCount,
  },
  markChatAsUnread: {
    key: 'MOCK_MARK_CHAT_AS_UNREAD',
    fn: markChatAsUnread,
  },
  checkContactsWith: {
    key: 'CHECK_CONTACTS_WITH',
    fn: checkContactsWith,
  },
  checkProfileAccess: {
    key: 'CHECK_PROFILE_ACCESS',
    fn: checkProfileAccess,
  },
}

export default chatApi
